import { PARTNER_STATUSES } from 'cpool-constants';
import { z } from 'zod';

import { PAGINATION } from '~/constants';

export const partnerListSearchSchema = z.object({
    /**
     * aggregateId of the partner whose detail modal is open. Keeping it in the URL makes the detail
     * view deep-linkable, even for a partner that is not on the current page – KC-6661
     */
    detailPartnerId: z.string().uuid().optional().catch(undefined),
    page: z.number().int().positive().optional().default(PAGINATION.DEFAULT_PAGE).catch(PAGINATION.DEFAULT_PAGE),
    pageSize: z
        .number()
        .refine((pageSize) => PAGINATION.PARTNER_LIST.PAGE_SIZE_OPTIONS.includes(pageSize))
        .optional()
        .default(PAGINATION.PARTNER_LIST.DEFAULT_PAGE_SIZE)
        .catch(PAGINATION.PARTNER_LIST.DEFAULT_PAGE_SIZE),
    /** Levels are plain strings: the partner API also delivers levels outside PARTNER_LEVELS – KC-6661 */
    partnerLevel: z.array(z.string()).optional().default([]).catch([]),
    /** Derived from the `locked` flag, so – unlike partnerLevel – this is a closed set – KC-6661 */
    partnerStatus: z.array(z.nativeEnum(PARTNER_STATUSES)).optional().default([]).catch([]),
    /** Free text matched server-side against name, company name, PID and e-mail – KC-6661 */
    search: z.string().optional().default('').catch(''),
});

export type PartnerListSearchSchema = z.infer<typeof partnerListSearchSchema>;
